export const batchCheckpointsTags = [
  'BatchCheckpoints',
  'BatchCheckpointsTransition',
] as const;
